// extracted by mini-css-extract-plugin
export default {"header":"S9jDS0RLDMZ5ml19buhZ","header-left":"AYw8oOzII8Iv5VHuv1DI","app-logo-button":"aqMemBR2ehaUMXbdpC9W","header-title":"VUgCDvNa9qwzwCUmrWWw"};